import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl, NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[onlyalpha]',
    standalone: false
})
export class OnlyAlphaDirective {


  constructor(private _el: ElementRef, private readonly ngModel: NgModel) { }

  
  @HostListener('keydown', ['$event']) onInputChange(event:KeyboardEvent) {
    const initalValue = event.key;
    var regex = new RegExp("^[a-zA-Z]+$");
    if (regex.test(initalValue)) {
        return true;
    }

    event.preventDefault();
    return false;    
  }

}